<div class="w-full bg-surface border border-border rounded-lg p-3 sm:p-4">
  <ng-content select="[filterPrepend]"></ng-content>
  <form [formGroup]="filterForm">
    <!-- All Filters and Buttons - Wrap Naturally, Bottom Aligned -->
    <div [ngClass]="getLayoutClasses()" [class.grid]="displayLayout === 'grid'"
      [style.grid-template-columns]="displayLayout === 'grid' ? 'repeat(' + displayColumns + ', 1fr)' : 'none'"
      [style.grid-template-rows]="displayLayout === 'grid' && config && config.gridRows ? 'repeat(' + config.gridRows + ', auto)' : null">
      <ng-container *ngFor="let field of displayFields">
        <div [class]="getFieldClasses(field)"
          [ngStyle]="displayLayout === 'grid' && field.config && (field.config.gridRow != null || field.config.gridColumn != null) ? getGridPlacementStyles(field) : null">
          <!-- Input Field (showEditIcon: pen inside field via app-input `icon`) -->
          <div *ngIf="field.type === 'input'" class="w-full" [ngStyle]="field.config?.containerStyle">
            <app-input
              [formControlName]="field.key"
              [label]="field.label"
              [placeholder]="field.placeholder || ''"
              [id]="field.key"
              [name]="field.key"
              [type]="field.config?.type || 'text'"
              [pattern]="field.config?.pattern"
              [required]="field.config?.required || false"
              [disabled]="field.config?.disabled || false"
              [readonly]="field.config?.readonly || false"
              [inputStyle]="field.config?.inputStyle"
              [labelStyle]="field.config?.labelStyle"
              [icon]="field.config?.showEditIcon ? 'fas fa-pen-to-square' : ''"
              [iconColor]="field.config?.showEditIcon ? 'text-[var(--primary)]' : 'text-slate-500 hover:text-primary'"
              [iconTitle]="field.config?.showEditIcon ? (field.config?.editIconTitle || 'Edit') : ''"
              (iconClick)="onInputFieldEdit(field)"></app-input>
            <app-form-error-message [control]="filterForm.get(field.key)" [fieldName]="field.label"></app-form-error-message>
          </div>

          <!-- Textarea Field -->
          <app-input *ngIf="field.type === 'textarea'" [formControlName]="field.key" [label]="field.label"
            [placeholder]="field.placeholder || ''" [id]="field.key" [name]="field.key" type="textarea"
            [rows]="field.config?.rows || 3" [required]="field.config?.required || false"
            [disabled]="field.config?.disabled || false" [readonly]="field.config?.readonly || false"
            [inputStyle]="field.config?.inputStyle" [labelStyle]="field.config?.labelStyle"></app-input>

          <!-- Dropdown Field (full width in grid like inputs) -->
          <div *ngIf="field.type === 'dropdown'" class="w-full min-w-0">
            <app-dropdown [formControlName]="field.key" [label]="field.label"
              [options]="field.options || []" [placeholder]="field.placeholder || 'Select an option'" [id]="field.key"
              [name]="field.key" [multiple]="field.config?.multiple || false"
              [required]="field.config?.required || false"></app-dropdown>
          </div>

          <!-- Multi-Select Field (Now using merged dropdown) -->
          <app-dropdown *ngIf="field.type === 'multi-select'" [formControlName]="field.key" [label]="field.label"
            [options]="field.options || []" [placeholder]="field.placeholder || 'Select options'" [id]="field.key"
            [multiple]="true" [required]="field.config?.required || false"
            [class]="'min-w-0 sm:min-w-[200px]'"></app-dropdown>

          <!-- Date Picker -->
          <app-date-picker *ngIf="field.type === 'date'" [formControlName]="field.key" [label]="field.label"
            [placeholder]="field.placeholder || 'mm/dd/yyyy'" [id]="field.key" [name]="field.key"
            [min]="field.config?.min" [max]="field.config?.max"
            [required]="field.config?.required || false"></app-date-picker>

          <!-- Time Picker -->
          <app-time-picker *ngIf="field.type === 'time'" [formControlName]="field.key" [label]="field.label"
            [placeholder]="field.placeholder || 'Select time'" [id]="field.key" [name]="field.key"
            [min]="field.config?.min" [max]="field.config?.max" [step]="field.config?.step"
            [required]="field.config?.required || false"></app-time-picker>

          <!-- Date-Time Picker (combines date and time) -->
          <div *ngIf="field.type === 'date-time'" class="flex flex-col sm:flex-row gap-2">
            <app-date-picker [formControlName]="field.key + '_date'" [label]="field.label + ' (Date)'"
              [placeholder]="'mm dd yyyy'" [id]="field.key + '_date'" [name]="field.key + '_date'"
              [min]="field.config?.min" [max]="field.config?.max" [required]="field.config?.required || false"
              class="flex-1 w-full"></app-date-picker>
            <app-time-picker [formControlName]="field.key + '_time'" [label]="field.label + ' (Time)'"
              [placeholder]="'Select time'" [id]="field.key + '_time'" [name]="field.key + '_time'"
              [min]="field.config?.timeMin" [max]="field.config?.timeMax" [step]="field.config?.step"
              [required]="field.config?.required || false" class="flex-1 w-full"></app-time-picker>
          </div>

          <!-- Practice-Location Combined Field -->
          <div *ngIf="field.type === 'practice-location'" class="flex flex-col sm:flex-row gap-2">
            <app-searchable-input-dropdown [formControlName]="field.key + '_location'" label="Location"
              [id]="field.key + '_location'" [name]="field.key + '_location'"
              [options]="field.config?.locationOptions || []" [isLoading]="field.config?.isLocationLoading || false"
              [serverSideSearch]="field.config?.serverSideSearch === true"
              [required]="field.config?.required || false"
              (searchQuery)="onSearchQuery(field.key + '_location', $event)"
              (focus)="onSearchableDropdownFocus(field.key + '_location')" class="flex-1 w-full">
            </app-searchable-input-dropdown>

            <app-searchable-input-dropdown [formControlName]="field.key + '_practice'" label="Practice"
              [id]="field.key + '_practice'" [name]="field.key + '_practice'"
              [options]="field.config?.practiceOptions || []" [isLoading]="field.config?.isPracticeLoading || false"
              [serverSideSearch]="field.config?.serverSideSearch === true"
              [required]="field.config?.required || false" [disabled]="field.config?.isPracticeDisabled !== false"
              (searchQuery)="onSearchQuery(field.key + '_practice', $event)"
              (focus)="onSearchableDropdownFocus(field.key + '_practice')" class="flex-1 w-full">
            </app-searchable-input-dropdown>
          </div>

          <!-- Radio Button Group (verticalOptions: stack options; bordered: dark 1px border box) -->
          <div *ngIf="field.type === 'radio'"
            [ngClass]="field.config?.verticalOptions
              ? 'flex flex-col border border-slate-400 rounded-md p-2.5'
              : (field.config?.stackLabel ? 'flex flex-col gap-1' : 'flex flex-wrap items-center gap-2 sm:gap-3')">
            <label *ngIf="field.label"
              class="text-xs font-semibold text-slate-600"
              [ngClass]="field.config?.verticalOptions || field.config?.stackLabel ? 'mb-1.5' : 'mr-2'">
              {{ field.label }}<ng-container *ngIf="!field.config?.verticalOptions && !field.config?.stackLabel">:</ng-container>
            </label>
            <div [ngClass]="field.config?.verticalOptions ? 'flex flex-col gap-2' : 'flex flex-wrap items-center gap-2 sm:gap-3'">
              <label *ngFor="let option of field.options" class="flex items-center cursor-pointer">
                <input type="radio" [formControlName]="field.key" [value]="option.value"
                  class="w-3 h-3 flex-shrink-0 mr-3 text-[var(--primary)] focus:ring-[var(--primary)]">
                <span class="text-xs text-slate-600">{{ option.label }}</span>
              </label>
            </div>
          </div>

          <!-- Checkbox Field (checkboxLabelFirst: legacy “Label :” then box) -->
          <div *ngIf="field.type === 'checkbox'" class="flex items-end h-full pb-2 w-full">
            <label *ngIf="!field.config?.checkboxLabelFirst" class="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" [formControlName]="field.key" [id]="field.key"
                class="rounded border-slate-300 text-[var(--primary)] w-4 h-4 focus:ring-primary shrink-0">
              <span class="text-sm font-semibold text-slate-700">{{ field.label }}</span>
            </label>
            <label *ngIf="field.config?.checkboxLabelFirst" class="flex items-center gap-2 cursor-pointer w-full min-h-[40px]">
              <span class="text-sm font-semibold text-slate-700 shrink-0">{{ field.label }}<ng-container *ngIf="field.config?.appendLabelColon">:</ng-container></span>
              <input type="checkbox" [formControlName]="field.key" [id]="field.key"
                [attr.aria-label]="field.label"
                class="rounded border-slate-300 text-[var(--primary)] w-4 h-4 focus:ring-primary shrink-0">
            </label>
          </div>

          <!-- Searchable Dropdown Field -->
          <app-searchable-input-dropdown *ngIf="field.type === 'searchable-dropdown'" [formControlName]="field.key"
            [label]="field.label" [placeholder]="field.placeholder || ''" [id]="field.key" [name]="field.key"
            [options]="field.searchableOptions || []" [isLoading]="field.isLoading || false"
            [serverSideSearch]="field.config?.serverSideSearch === true"
            [required]="field.config?.required || false" [disabled]="field.config?.disabled || false"
            [displayLabelForValue]="getSearchableDisplayLabel(field)"
            [icon]="field.config?.showEditIcon ? 'fas fa-pen-to-square' : ''"
            [iconColor]="field.config?.showEditIcon ? 'text-[var(--primary)]' : 'text-slate-500 hover:text-primary'"
            [iconDisabled]="field.config?.iconDisabled === true"
            [iconTitle]="field.config?.showEditIcon ? (field.config?.editIconTitle || 'Edit') : ''"
            (searchQuery)="onSearchQuery(field.key, $event)"
            (focus)="onSearchableDropdownFocus(field.key)"
            (valueChange)="onSearchableValueChange(field, $event)"
            (iconClick)="onInputFieldEdit(field)"></app-searchable-input-dropdown>

          <!-- Find + Reset: splitFindReset = ends apart; findResetGroupRight = both grouped on the right -->
          <div *ngIf="field.type === 'find-reset-buttons'"
            class="flex items-end pb-1"
            [ngClass]="field.config?.splitFindReset ? 'w-full justify-between gap-4' : (field.config?.findResetGroupRight ? 'w-full justify-end gap-2' : 'gap-2')">
            <button type="button" (click)="onFind()"
              [disabled]="findLoading"
              class="px-4 py-2 bg-primary text-white rounded-lg hover:brightness-110 active:translate-y-px active:scale-[0.98] transition-all duration-150 font-medium text-sm shrink-0 inline-flex items-center justify-center gap-2 disabled:opacity-65 disabled:cursor-not-allowed disabled:pointer-events-none disabled:hover:brightness-100">
              <i *ngIf="findLoading" class="fas fa-spinner fa-spin text-sm" aria-hidden="true"></i>
              <span>{{ field.config?.findLabel || 'Find' }}</span>
            </button>
            <button type="button" (click)="onReset()"
              class="px-4 py-2 bg-slate-200 text-slate-800 rounded-lg hover:bg-slate-300 active:translate-y-px active:scale-[0.98] transition-all duration-150 font-medium text-sm shrink-0">
              Reset
            </button>
          </div>

          <!-- Find Button (standalone) -->
          <div *ngIf="field.type === 'find-button'"
            class="flex items-end pb-1"
            [ngClass]="field.config?.findButtonAlignRight ? 'w-full justify-end' : ''">
            <button type="button" (click)="onFind()"
              [disabled]="findLoading"
              class="px-4 py-2 bg-primary text-white rounded-lg hover:brightness-110 active:translate-y-px active:scale-[0.98] transition-all duration-150 font-medium text-sm inline-flex items-center justify-center gap-2 disabled:opacity-65 disabled:cursor-not-allowed disabled:pointer-events-none disabled:hover:brightness-100">
              <i *ngIf="findLoading" class="fas fa-spinner fa-spin text-sm" aria-hidden="true"></i>
              <span>{{ field.config?.findLabel || 'Find' }}</span>
            </button>
          </div>

          <!-- Reset Button (standalone) -->
          <div *ngIf="field.type === 'reset-button'" class="flex items-end pb-1">
            <button type="button" (click)="onReset()"
              class="px-4 py-2 bg-slate-200 text-slate-800 rounded-lg hover:bg-slate-300 active:translate-y-px active:scale-[0.98] transition-all duration-150 font-medium text-sm">
              Reset
            </button>
          </div>
        </div>
        <!-- (inline reset removed - use page-level Reset button) -->
      </ng-container>

      <ng-content select="[filterAppend]"></ng-content>

      <!-- Reset button removed from filter area (handled at page header) -->

      <!-- Action Buttons - Search and Reset -->
      <div *ngIf="showApplyButton || showResetButton" [class.col-span-full]="displayLayout === 'grid' && config && !config.actionButtonsGrid" [class.justify-self-end]="displayLayout === 'grid'" [class.self-end]="displayLayout === 'grid'"
        [ngStyle]="getApplyResetButtonGridStyle()"
        class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto sm:ml-auto mt-2 sm:mt-0">
        <button *ngIf="showApplyButton" type="button" (click)="onApply()"
          [disabled]="applyLoading || resetLoading"
          class="px-4 sm:px-6 py-2 bg-primary text-white rounded-lg hover:opacity-90 transition-opacity font-medium text-sm w-full sm:w-auto inline-flex items-center justify-center gap-2 disabled:opacity-65 disabled:cursor-not-allowed disabled:pointer-events-none">
          <i *ngIf="applyLoading" class="fas fa-spinner fa-spin text-sm" aria-hidden="true"></i>
          <span>{{ displayApplyLabel }}</span>
        </button>
        <button *ngIf="showResetButton" type="button" (click)="onReset()"
          [disabled]="resetLoading || applyLoading"
          class="px-4 sm:px-6 py-2 bg-slate-200 text-slate-800 rounded-lg hover:bg-slate-300 transition-colors font-medium text-sm w-full sm:w-auto inline-flex items-center justify-center gap-2 disabled:opacity-65 disabled:cursor-not-allowed disabled:pointer-events-none">
          <i *ngIf="resetLoading" class="fas fa-spinner fa-spin text-sm" aria-hidden="true"></i>
          <span>Reset</span>
        </button>
      </div>
    </div>
  </form>
</div>